import { atom } from 'jotai';

export interface CartTrackingProperties {
  id: string;
  currency: string;
  items: {
    productId: string;
    variantId: string;
    unitPrice: number;
    count: number;
    totalDiscountedPrice: number;
    productTitle: string;
    variantTitle: string;
  }[];
  shipping: {
    country: string;
    city: string;
  };
  selectedShippingMethod?: {
    id: string;
    title: string;
    type: string;
    price: number;
    totalDiscountedPrice: number;
  };
  paymentMethod?: {
    type: string;
  };
  discounts: {
    code: string;
  }[];
  price: {
    cartAmount: number;
    shippingAmount: number;
    totalAmount: number;
  };
}

export interface GlobalPropertiesTrackingProperties {
  shop?: string;
  shopName?: string;
  shopId?: string;
  language?: string;
  cartId?: string;
  platform?: string;
  source?: string;
  analyticsSource?: string;
  posthogSessionId?: string;
  posthogSessionUrl?: string;
  isAuthenticated?: boolean;
  checkoutTheme?: string;
  cart?: CartTrackingProperties;
  totalCartQuantity?: number;
  [key: string]: unknown;
}

export const globalPropertiesTrackAtom = atom<GlobalPropertiesTrackingProperties>({});
